import { useError } from '@/libs/error'
import { ErrorParams } from '@/libs/error/models/errorParams.model'
import { HttpInstance } from '@/libs/http'

export default abstract class ABaseService {
  protected clientHttp: HttpInstance

  constructor(clientHttp: HttpInstance) {
    this.clientHttp = clientHttp
  }

  protected setError = (params: ErrorParams) => {
    const { setError } = useError()
    setError(params)
  }
}
